import { __assign, __generator } from "tslib";
import { put, takeLatest, select, delay } from 'redux-saga/effects';
import i18next from 'i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { getIsLoggedIn, getIsMobile, getIsVerificationNeeded, } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import { scrollIntoViewWithHeader } from '../../utils/scrollIntoViewWithHeader';
import { pushVerificationPopup } from '../../VerificationPopup/actions';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { publishComment, publishCommentSuccess, publishCommentFailure, focusEditor, focusEditorWithScroll, } from './actionCreators';
import { RequestError, } from './types';
import { sendPublishRequest } from './utils';
import { putErrorNotification } from '../../utils/saga';
function getError(result) {
    if (result &&
        result.errorCode !== undefined &&
        RequestError[result.errorCode] !== undefined) {
        return { error: result.errorCode, errorMsg: result.errorDescription };
    }
    return {
        error: RequestError.GeneralError,
        errorMsg: result.errorDescription,
    };
}
export function publishCommentHandler(action) {
    var _a, editComment, replyComment, editorId, messageId, shouldDeleteMessage, _b, isLoggedIn, isVerificationNeeded, result, publishResult, violations, violation, _c;
    var _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = action.payload, editComment = _a.editComment, replyComment = _a.replyComment, editorId = _a.editorId, messageId = _a.messageId, shouldDeleteMessage = _a.shouldDeleteMessage;
                return [4 /*yield*/, select(function (state) { return ({
                        isLoggedIn: getIsLoggedIn(state),
                        isVerificationNeeded: getIsVerificationNeeded(state),
                    }); })];
            case 1:
                _b = _f.sent(), isLoggedIn = _b.isLoggedIn, isVerificationNeeded = _b.isVerificationNeeded;
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.COMMENT_ACTION }))];
            case 2:
                _f.sent();
                return [2 /*return*/];
            case 3:
                if (!isVerificationNeeded) return [3 /*break*/, 5];
                return [4 /*yield*/, put(pushVerificationPopup('comment'))];
            case 4:
                _f.sent();
                return [2 /*return*/];
            case 5: return [4 /*yield*/, sendPublishRequest(action.payload)];
            case 6:
                result = _f.sent();
                if (!(result && !result.error)) return [3 /*break*/, 8];
                publishResult = {
                    editorId: editorId,
                    comment: result,
                    isEdit: !!editComment,
                    isReply: !!replyComment,
                    messageId: messageId,
                    shouldDeleteMessage: shouldDeleteMessage,
                };
                return [4 /*yield*/, put(publishCommentSuccess(publishResult))];
            case 7:
                _f.sent();
                return [3 /*break*/, 18];
            case 8:
                if (!((result === null || result === void 0 ? void 0 : result.errorCode) === 302)) return [3 /*break*/, 9];
                window.location.replace(result.errorDetails.redirectUrl);
                return [3 /*break*/, 14];
            case 9:
                if (!((result === null || result === void 0 ? void 0 : result.errorDetails) &&
                    result.errorDetails.errorType === 'media_content_violation')) return [3 /*break*/, 14];
                violations = (_d = result.errorDetails.violations) !== null && _d !== void 0 ? _d : [];
                if (!(violations.length > 0)) return [3 /*break*/, 14];
                violation = violations[0];
                _c = violation === null || violation === void 0 ? void 0 : violation.mediaType;
                switch (_c) {
                    case 'wix-draft-plugin-giphy': return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, put(pushModal(ModalType.CONFIRMATION, {
                    params: {
                        title: i18next.t('commentbox.error.tooManyGifs.title'),
                        text: i18next.t('commentbox.error.tooManyGifs.text'),
                    },
                }))];
            case 11:
                _f.sent();
                return [3 /*break*/, 14];
            case 12: return [4 /*yield*/, put(pushModal(ModalType.CONFIRMATION, {
                    params: {
                        title: i18next.t('commentbox.error.generic.title'),
                        text: i18next.t('common.somethingWentWrong'),
                    },
                }))];
            case 13:
                _f.sent();
                return [3 /*break*/, 14];
            case 14:
                if (!(((_e = result.errorDetails) === null || _e === void 0 ? void 0 : _e.errorType) !== 'media_content_violation')) return [3 /*break*/, 16];
                return [4 /*yield*/, putErrorNotification(i18next.t('comment.error.post', { error: getError(result).errorMsg }))];
            case 15:
                _f.sent();
                _f.label = 16;
            case 16: return [4 /*yield*/, put(publishCommentFailure(__assign({ editorId: editorId, isEdit: !!editComment, isReply: !!replyComment }, getError(result))))];
            case 17:
                _f.sent();
                _f.label = 18;
            case 18: return [2 /*return*/];
        }
    });
}
export function focusHandler(_a) {
    var editor, isMobile;
    var _b = _a.payload, editorId = _b.editorId, smoothScroll = _b.smoothScroll;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                editor = document.getElementById(editorId);
                return [4 /*yield*/, select(getIsMobile)];
            case 1:
                isMobile = _c.sent();
                if (!editor) return [3 /*break*/, 4];
                scrollIntoViewWithHeader(editor, isMobile, 100, undefined, smoothScroll);
                return [4 /*yield*/, delay(500)];
            case 2:
                _c.sent();
                return [4 /*yield*/, put(focusEditor(editorId))];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(publishComment, publishCommentHandler)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(focusEditorWithScroll, focusHandler)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map